module.exports = __webpack_public_path__ + "static/secondMovementLastSnippet2-c8436f9d8f1d78917183fe8b417916c8.mp3";